const app = require('./app.js');
const loadingCircle = require("./ui.loadingCircle.js");
const {Template} = require('./ui.template.js');

class deviceLocation extends Template{

    dataType = 'location';
    wsName = 'getLocationsForDevice'

    init(device_id){
        this.itemsPerFetch = 75;
        this.device_id = device_id;
        this.tabLabel = document.querySelector(`button[data-tab="locations"]`);
        const oldOnclick = this.tabLabel.onclick;
        const self = this;
        this.tabLabel.onclick = ()=>{
            if(typeof oldOnclick === 'function')
                oldOnclick()
                self.show();
        }
    }

    show(){
        const isTimelineEmpty = this.isTimelineEmpty(document.getElementById('location'));
        if(isTimelineEmpty){
            app.webSocket.sendMessage({type: this.wsName, device_id:this.device_id, from: 0, to: this.itemsPerFetch});
            this.loadingCircle = loadingCircle;
            loadingCircle.show(document.body);
        }
    }
}

module.exports = deviceLocation;